(() => {
  const initFloatingActions = () => {
    const dialog = document.getElementById('MSQuickQuote');
    const openButton = document.querySelector('[data-ms-quote-open]');
    if (!dialog || !openButton || dialog.dataset.msBound === 'true') return;

    dialog.dataset.msBound = 'true';
    const closeButton = dialog.querySelector('[data-ms-quote-close]');
    const firstField = dialog.querySelector('input:not([type="hidden"]),select,textarea');
    const result = dialog.querySelector('[data-ms-quote-result]');

    const openDialog = () => {
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      document.body.classList.add('ms-quote-open');
      window.setTimeout(() => (result || firstField || closeButton)?.focus?.(), 40);
    };

    const closeDialog = () => {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
      document.body.classList.remove('ms-quote-open');
    };

    openButton.addEventListener('click', openDialog);
    closeButton?.addEventListener('click', closeDialog);
    dialog.addEventListener('close', () => document.body.classList.remove('ms-quote-open'));
    dialog.addEventListener('cancel', () => document.body.classList.remove('ms-quote-open'));
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });

    if (result) openDialog();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFloatingActions, { once: true });
  } else {
    initFloatingActions();
  }

  document.addEventListener('shopify:section:load', initFloatingActions);
})();
